import { plaintextValidator } from '../fields';

const config = { mandatory: true };

// const prefix = 'scheduleDefinition.data.';
const prefix = '';

const getMonthType = (type) => {
  switch (type) {
    case 'DAY_OF_MONTH':
      return { [`${prefix}dayOfMonth`]: plaintextValidator(config) };
    case 'WEEK_OF_MONTH':
      return {
        [`${prefix}week`]: plaintextValidator(config),
        [`${prefix}dayOfWeek`]: plaintextValidator(config)
      };
    default:
      return {};
  }
};

const getScheduleObject = (type, monthType) => {
  const baseCondition = {
    [`${prefix}startDate`]: plaintextValidator(config)
  };
  switch (type) {
    case 'WEEKLY':
      return {
        [`${prefix}dayOfWeek`]: plaintextValidator(config),
        ...baseCondition
      };
    case 'MONTHLY':
      return {
        [`${prefix}type`]: plaintextValidator(config),
        // week: plaintextValidator(config),
        // dayOfWeek: plaintextValidator(config),
        // dayOfMonth: plaintextValidator(config), //only if type is DAY_OF_MONTH and not WEEK_OF_MONTH
        ...getMonthType(monthType),
        ...baseCondition
      };
    case 'HOURLY':
    case 'DAILY':
    default:
      return baseCondition;
  }
};

export default (type, monthType = '') => ({
  ...getScheduleObject(type, monthType)
});

export const clientSignatureValidator = {
  name: plaintextValidator(config)
};
